import { Injectable } from '@angular/core';
import { paramsShowScreenSet, paramsGetAccountInfo, paramsisAvailableLoginID } from '../../types/gigya-type';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { environment } from 'src/environments/environment';

declare let gigya: any;

@Injectable({
  providedIn: 'root'
})
export class GigyaService {
  isGigyaLoaded = new BehaviorSubject(false);
  isGigyaLoaded$ = this.isGigyaLoaded.asObservable();
  constructor() {
  }
  onGigyaServiceReady() {
    if (typeof gigya != 'undefined') {
      this.isGigyaLoaded.next(true);
    } else {
      fromEvent(document, 'panini:onGigyaServiceReady').subscribe((ev: any) => {
        this.isGigyaLoaded.next(true);
      });
    }
  }

  showScreenSet(params: paramsShowScreenSet) {
    gigya.accounts.showScreenSet(params);
  }
  getAccountInfo(params: paramsGetAccountInfo) {
    gigya.accounts.getAccountInfo(params);
  }
  setAccountInfo(params: any) {
    gigya.accounts.setAccountInfo(params);
  }
  isAvailableLoginID(params: paramsisAvailableLoginID) {
    gigya.accounts.isAvailableLoginID(params);
  }

  logout() {
    gigya.accounts.logout();
  }

  loadCDC(){
    let header :HTMLElement | null = document.querySelector('head'); 
    let src = `https://cdns.eu1.gigya.com/js/gigya.js?apikey=${environment.APIKey}`;

    let script = document.createElement("script");
    script.src = src;
    script.type = "text/javascript";
    header?.appendChild(script);
  }

  loadCookiebot(lang:string){
    let footer :HTMLElement | null = document.querySelector('footer'); 
    //let social :HTMLElement | null = document.querySelector('.socialsContainer'); 

    let src = `https://consent.cookiebot.com/e360ce47-3b41-46a1-8517-e0c59e204310/cd.js`;

    let script: HTMLScriptElement  = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = src;
    script.type = "text/javascript";
    script.setAttribute("data-culture",lang);
    footer?.appendChild(script);
    //social?.insertAdjacentElement("afterend",script);
  }
  hideScreenSet(divID:string){
    gigya.accounts.hideScreenSet({containerID: divID});
  }
  
}
